import React, { useEffect, useRef } from 'react';

const SkipEyeLogoTargeted = ({ size = 'large', targetPosition = null }) => {
  const logoRef = useRef(null);
  const leftPupilRef = useRef(null);
  const rightPupilRef = useRef(null);

  const dimensions = size === 'large' ? { width: 500, height: 200 } : { width: 300, height: 120 };

  useEffect(() => {
    const updateEyePosition = () => {
      if (!logoRef.current || !leftPupilRef.current || !rightPupilRef.current) return;
      if (!targetPosition) return;

      const logoRect = logoRef.current.getBoundingClientRect();
      const logoCenterX = logoRect.left + logoRect.width / 2;
      const logoCenterY = logoRect.top + logoRect.height / 2;

      const angle = Math.atan2(targetPosition.y - logoCenterY, targetPosition.x - logoCenterX);
      const distance = Math.min(15, Math.sqrt(Math.pow(targetPosition.x - logoCenterX, 2) + Math.pow(targetPosition.y - logoCenterY, 2)) / 10);

      const pupilX = Math.cos(angle) * distance;
      const pupilY = Math.sin(angle) * distance;

      const transform = `translate(calc(-50% + ${pupilX}px), calc(-50% + ${pupilY}px))`;
      leftPupilRef.current.style.transform = transform;
      rightPupilRef.current.style.transform = transform;
    };

    updateEyePosition();
  }, [targetPosition]);

  const styles = {
    logoContainer: {
      position: 'relative',
      width: `${dimensions.width}px`,
      height: `${dimensions.height}px`,
      cursor: 'pointer'
    },
    skipContainer: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    containerBody: {
      position: 'absolute',
      bottom: 0,
      left: '15%',
      right: '15%',
      height: '85%',
      background: 'linear-gradient(135deg, #7dd321 0%, #5cb41b 100%)',
      clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 20% 100%)',
      borderRadius: '0 0 8px 8px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
    },
    containerRim: {
      position: 'absolute',
      bottom: '85%',
      left: '10%',
      right: '10%',
      height: '15%',
      background: 'linear-gradient(135deg, #8ee524 0%, #7dd321 100%)',
      borderRadius: '8px 8px 0 0',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    },
    eye: {
      position: 'absolute',
      width: size === 'large' ? '70px' : '42px',
      height: size === 'large' ? '70px' : '42px',
      background: 'white',
      borderRadius: '50%',
      border: '4px solid #333',
      top: '45%',
      transform: 'translateY(-50%)',
      overflow: 'hidden',
      transition: 'all 0.1s ease-out'
    },
    leftEye: {
      left: '34.5%'
    },
    rightEye: {
      right: '34.5%'
    },
    pupil: {
      position: 'absolute',
      width: size === 'large' ? '40px' : '24px',
      height: size === 'large' ? '40px' : '24px',
      background: '#222',
      borderRadius: '50%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      transition: 'transform 0.5s ease-out'  // Smooth transition when eyes move
    },
    highlight: {
      position: 'absolute',
      width: size === 'large' ? '14px' : '8px',
      height: size === 'large' ? '14px' : '8px',
      background: 'white',
      borderRadius: '50%',
      top: '30%',
      left: '35%',
      pointerEvents: 'none'
    }
  };

  return (
    <div ref={logoRef} style={styles.logoContainer}>
      <div style={styles.skipContainer}>
        <div style={styles.containerRim}></div>
        <div style={styles.containerBody}></div>

        <div style={{...styles.eye, ...styles.leftEye}}>
          <div ref={leftPupilRef} style={styles.pupil}>
            <div style={styles.highlight}></div>
          </div>
        </div>

        <div style={{...styles.eye, ...styles.rightEye}}>
          <div ref={rightPupilRef} style={styles.pupil}>
            <div style={styles.highlight}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkipEyeLogoTargeted;
